import { Box, Button, Fade, MenuItem, Typography, useTheme } from '@mui/material';
import TrapFocus from '@mui/material/Unstable_TrapFocus';
import { useIntl } from 'react-intl';

import Select from 'components/select';
import { useState } from 'react';
import ScenarioCloneDialog from 'views/bluviu-nutrition/features/scenarios-v2/components/scenario-clone-dialog';
import { useR2ScenarioState } from 'views/bluviu-nutrition/features/scenarios-v2/context/r2-scenario-context';
import { Summary } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-result.type';

type Props = {
  selectedFeedPlans: Summary[];
  showCompareBottomBar: boolean;
  clearSelection: () => void;
  tabChange?: () => void;
};

enum CompareActions {
  Compare = 'Compare',
  Clone = 'Clone feed program',
}

const ScenarioBottomCompareBar: React.FC<Props> = ({ selectedFeedPlans, showCompareBottomBar, clearSelection, tabChange }) => {
  const theme = useTheme();
  const [selectedAction, setSelectedAction] = useState('');
  const {
    r2ScenarioQuery: { data: scenario },
  } = useR2ScenarioState();
  const intl = useIntl();

  const actions = [
    {
      label: 'Compare',
      action: CompareActions.Compare,
      onClick: () => console.log('Compare feeds'),
    },
    {
      label: 'Clone feed program',
      action: CompareActions.Clone,
      onClick: () => console.log('Clone feed program'),
    },
  ];

  return (
    <TrapFocus open={showCompareBottomBar} disableAutoFocus disableEnforceFocus>
      <Fade appear={false} in={showCompareBottomBar}>
        <Box
          display={showCompareBottomBar ? 'flex' : 'none'}
          justifyContent={'center'}
          alignItems={'center'}
          flexDirection={'row'}
          sx={{
            background: theme.palette.blue.o25,
            position: 'fixed',
            bottom: 10,
            left: 20,
            right: 20,
            height: 96,
            zIndex: 1300,
            borderRadius: 2,
          }}>
          <Box
            display={'flex'}
            flexDirection={'row'}
            alignItems={'center'}
            gap={4}
            flexGrow={2}
            justifyContent={'center'}
            width={'fit-content'}>
            <Typography color={theme.palette.primary.main}>{selectedFeedPlans.length} programs selected</Typography>
            <Box display={'flex'} gap={2}>
              <Select
                dark
                label={'Select action'}
                value={selectedAction}
                MenuProps={{
                  disablePortal: true,
                }}
                onChange={(e) => {
                  setSelectedAction(e.target.value as string);
                }}>
                {actions.map((action) => (
                  <MenuItem key={action.label} value={action.label}>
                    {action.label}
                  </MenuItem>
                ))}
              </Select>
              {selectedAction === CompareActions.Compare && (
                <Button
                  variant="contained"
                  onClick={() => {
                    tabChange && tabChange();
                    setSelectedAction('');
                  }}>
                  Show
                </Button>
              )}
              {selectedAction === CompareActions.Clone && scenario && (
                <ScenarioCloneDialog
                  scenario={scenario}
                  selectedFeedProgramIds={selectedFeedPlans.map((fp) => fp.feedPlan)}
                  button={
                    <Button disabled={!selectedAction} variant="contained">
                      Show
                    </Button>
                  }
                />
              )}
            </Box>
          </Box>
          <Box>
            <Button
              variant="text"
              sx={{
                backgroundColor: 'transparent',
              }}
              onClick={() => clearSelection()}>
              <Typography color={theme.palette.darkBlue.contrastText} fontWeight={600}>
                Clear
              </Typography>
            </Button>
          </Box>
        </Box>
      </Fade>
    </TrapFocus>
  );
};

export default ScenarioBottomCompareBar;
